
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
// eslint-disable-next-line no-unused-vars
//import { ConfigTopNode } from '../types'

import ZkTable from 'vue-table-with-tree-grid'

@Component({
  computed: {
    ...mapGetters({
      getSelectedNodeType: 'getSelectedNodeType',
      getSelectedNodeName: 'getSelectedNodeName',
      getSelectedNodeCType: 'getSelectedNodeCType',
      getSelectedNodeChildren: 'getSelectedNodeChildren',
      getSelectedModuleChildrenIds: 'getSelectedModuleChildrenIds',
      getPathsContainingCurrentNode: 'getPathsContainingCurrentNode',
      getDarkMode: 'getDarkMode',
      getConfigLoaded: 'getConfigLoaded',
      getStartLoadingConfig: 'getStartLoadingConfig',
      getConfigNodesMap: 'getConfigNodesMap',
    }),
    // ...mapState('sequence', ['sequences']),
  },
  components: {
    ZkTable,
  },
})
export default class TableView extends Vue {
  @Watch('getDarkMode')
  // eslint-disable-next-line no-unused-vars
  onDarkModeChanged(val: any, oldVal: any) {
    //console.log('open VAL:' + val)
    //console.log('open OLDVAL: ' + oldVal)
    let prevActive = this.activeColor
    let prevBackground = this.backGroundColor
    this.activeColor = prevBackground
    this.backGroundColor = prevActive
    if (this.activeHeaderBGColor == this.headerBackGroundColor1)
      this.activeHeaderBGColor = this.headerBackGroundColor2
    else this.activeHeaderBGColor = this.headerBackGroundColor1
    this.changeHeaderBGColor(this.activeHeaderBGColor)
  }

  private getSelectedNodeType!: any
  private getSelectedNodeName!: string
  private getSelectedNodeCType!: string
  private getSelectedNodeChildren!: Array<Object> | undefined
  private getSelectedModuleChildrenIds!: Array<any> | undefined
  private getPathsContainingCurrentNode!: any[]
  private getDarkMode!: any[]
  private getConfigNodesMap!: Object

  @Prop({ default: false }) readonly stripe!: boolean
  @Prop({ default: true }) readonly border!: boolean
  @Prop({ default: true }) readonly showHeader!: boolean //there is no option for sticky header
  @Prop({ default: false }) readonly showSummary!: boolean
  @Prop({ default: false }) readonly showRowHover!: boolean
  @Prop({ default: false }) readonly showIndex!: boolean
  @Prop({ default: true }) readonly treeType!: boolean
  @Prop({ default: true }) readonly isFold!: boolean
  @Prop({ default: false }) readonly expandType!: boolean
  @Prop({ default: false }) readonly selectionType!: boolean

  private activeColor: string = '#212121'
  private backGroundColor: string = 'white'
  private headerBackGroundColor1: string = '#f8f8f9'
  private headerBackGroundColor2: string = '#37474F'
  private activeHeaderBGColor: string = this.headerBackGroundColor1
  private fontSize: any = 16
  private font_family: any = 'Roboto, sans-serif'

  private columns: any = [
    {
      label: 'Name',
      prop: 'name',
      width: '250px',
    },
    {
      label: 'Type',
      prop: 'type',
      width: '100px',
    },
    {
      label: 'Value',
      prop: 'value',
      width: '250px',
    },
    {
      label: 'Trkd',
      prop: 'trkd',
      type: 'template',
      template: 'trkd',
      width: '50px',
    },
    {
      label: 'Dft',
      prop: 'dft',
      type: 'template',
      template: 'dft',
      width: '50px',
    },
  ]

  public blabla() {
    console.log('BLABLA')
  }

  public buildRecursiveVPSetObject(
    vpSetObject: Object,
    children: Array<Object>
  ) {
    // eslint-disable-next-line no-unused-vars
    for (const [key, childObject] of Object.entries(children)) {
      let nestedNoNamePSetObject: Object = {} //might or might not be used
      if (childObject['name'] == 'PSet') {
        //console.log('NESTED UNNAMED PSET')
        //console.log('UNNAMED PSET OBJECT TYPE: ' + childObject.type)
        nestedNoNamePSetObject['type'] == 'PSet'
        nestedNoNamePSetObject['name'] = 'PSet' //no name
        nestedNoNamePSetObject['dft'] = false
        nestedNoNamePSetObject['trkd'] = true
        nestedNoNamePSetObject['children'] = []
      }
      //console.log(JSON.stringify(key), JSON.stringify(childObject))
      // eslint-disable-next-line no-unused-vars
      let nestedVPSetObject: Object = {
        value: '',
        trkd: true,
        dft: true,
      }

      nestedVPSetObject['type'] = childObject['type']
      if (childObject['name'] == 'PSet') {
        this.buildRecursiveVPSetObject(
          nestedNoNamePSetObject,
          childObject['children']
        )
      } else if (
        nestedVPSetObject['type'] == 'cms.VPSet' ||
        nestedVPSetObject['type'] == 'cms.PSet' ||
        nestedVPSetObject['type'] == 'cms.untracked.PSet' ||
        nestedVPSetObject['type'] == 'cms.untracked.VPSet'
      ) {
        //console.log('PSET NAME: ' + key1)
        nestedVPSetObject['name'] = childObject['name']
        nestedVPSetObject['children'] = []

        this.buildRecursiveVPSetObject(
          nestedVPSetObject,
          childObject['children']
        )
      } else {
        nestedVPSetObject['name'] = childObject['name'].substring(
          0,
          childObject['name'].indexOf(' ')
        )

        nestedVPSetObject['value'] = JSON.stringify(
          childObject['paremeterJSONValue'],
          null,
          ' '
        ) //simple value
      }

      if (nestedVPSetObject['type'] != undefined) {
        let cmsTypeLenght = nestedVPSetObject['type'].length
        let cmsType = nestedVPSetObject['type'].substring(
          //cmsType is necessary for printing out in tree
          nestedVPSetObject['type'].indexOf('.') + 1,
          cmsTypeLenght
        )
        nestedVPSetObject['type'] = cmsType
      }
      //nestedModuleObject['name'] = nestedModuleObject['value']
      if (childObject['name'] != 'PSet') {
        vpSetObject['children'].push(nestedVPSetObject)
      } else if (childObject['name'] == 'PSet') {
        vpSetObject['children'].push(nestedNoNamePSetObject)
      }
    }
  }

  public parseChildren(
    childrenOrChildrenIds: Array<any> | undefined,
    nodeType: string
  ) {
    //console.log('PARAMS: ' + JSON.stringify(childrenOrChildrenIds)) //TODO: parse children
    //console.log('NODETYPE: ' + nodeType)

    if (childrenOrChildrenIds == undefined) return
    let paramsArray: any = []

    if (
      nodeType == 'pset' ||
      nodeType == 'modules' ||
      nodeType == 'esproducers' ||
      nodeType == 'essources' ||
      nodeType == 'services'
    ) {
      let children: Array<any> = []
      if (nodeType != 'modules') children = childrenOrChildrenIds
      else {
        //form module children array
        for (let i = 0; i < childrenOrChildrenIds.length; i++) {
          children.push(this.getConfigNodesMap[childrenOrChildrenIds[i]])
        }
      }
      //console.log('CHILDREN: ' + JSON.stringify(children))
      // eslint-disable-next-line no-unused-vars
      for (const [key, childObject] of Object.entries(children)) {
        this.parseInnerParams(childObject, paramsArray)
      }
    } else if (nodeType == 'cpuGpu' || nodeType == 'cpuGpuNested') {
      // eslint-disable-next-line no-unused-vars
      for (const [key, childObject] of Object.entries(
        childrenOrChildrenIds[0].children as Array<Object>
      )) {
        this.parseInnerParams(childObject, paramsArray)
      }
    }
    //console.log('paramsArray:' + JSON.stringify(paramsArray))
    return paramsArray
  }

  public parseInnerParams(childObject: Object, paramsArray: any) {
    let nestedParameterObject: Object = {
      //id: this.idCounter++,
      //children: [],
      dft: true,
      trkd: true,
      children: [],
    }

    nestedParameterObject['type'] = childObject['type']
    if (
      nestedParameterObject['type'] == 'cms.VPSet' ||
      nestedParameterObject['type'] == 'cms.PSet' ||
      nestedParameterObject['type'] == 'cms.untracked.PSet' ||
      nestedParameterObject['type'] == 'cms.untracked.VPSet'
    ) {
      nestedParameterObject['children'] = []
      nestedParameterObject['name'] = childObject['name']
      nestedParameterObject['value'] = ''

      this.buildRecursiveVPSetObject(
        nestedParameterObject,
        childObject['children']
      )
    } else {
      nestedParameterObject['name'] = childObject['name'].substring(
        0,
        childObject['name'].indexOf(' ')
      )
      //simple type
      nestedParameterObject['value'] = JSON.stringify(
        childObject['paremeterJSONValue'],
        null,
        ' '
      ) //simple value
      if (nestedParameterObject['value'].length > 70) {
        //shorten the string and put three dots in the end
        nestedParameterObject['value'] =
          nestedParameterObject['value'].substring(1, 70) + '...'
      }
    }

    if (nestedParameterObject['type'] != undefined) {
      let cmsTypeLenght = nestedParameterObject['type'].length
      let cmsType = nestedParameterObject['type'].substring(
        //cmsType is necessary for printing out in tree
        nestedParameterObject['type'].indexOf('.') + 1,
        cmsTypeLenght
      )
      nestedParameterObject['type'] = cmsType
      //console.log(nestedParameterObject)
    }
    //push parameter into module children
    paramsArray.push(nestedParameterObject)

    return paramsArray
  }

  public getSelectedNodeParams(nodeType: string) {
    //console.log('SELECTED NODE TYPE: ' + nodeType)
    if (
      nodeType == 'pset' ||
      nodeType == 'esproducers' ||
      nodeType == 'essources' ||
      nodeType == 'services' ||
      nodeType == 'cpuGpu' ||
      nodeType == 'cpuGpuNested'
    ) {
      return this.parseChildren(this.getSelectedNodeChildren, nodeType)
    } else if (nodeType == 'modules') {
      return this.parseChildren(this.getSelectedModuleChildrenIds, nodeType)
    } else if (nodeType == 'sequences') {
      return []
    } else if (nodeType == 'paths') {
      return []
    }
    return []
  }

  public getSelectedNodeLabelType(nodeType: string) {
    if (nodeType == 'modules') {
      return 'EDProducer'
    } else if (nodeType == 'sequences') {
      return ''
    } else if (nodeType == 'paths') {
      return ''
    } else if (nodeType == 'pset') {
      return ''
    } else if (nodeType == 'esproducers') {
      return 'ESProducer'
    } else if (nodeType == 'essources') {
      return 'ESSource'
    } else if (nodeType == 'services') {
      return 'Service'
    }
    return ''
  }

  public getSelectedNodeCTypeValue(nodeType: string) {
    if (
      nodeType == 'modules' ||
      nodeType == 'esproducers' ||
      nodeType == 'essources' ||
      nodeType == 'services'
    ) {
      return this.getSelectedNodeCType
    } else if (nodeType == 'sequences') {
      return ''
    } else if (nodeType == 'paths') {
      return ''
    } else if (nodeType == 'pset') {
      return ''
    }
    return ''
  }

  public getSelectedNodeLabel(nodeType: string) {
    if (
      nodeType == 'modules' ||
      nodeType == 'pset' ||
      nodeType == 'esproducers' ||
      nodeType == 'essources' ||
      nodeType == 'services'
    ) {
      return this.getSelectedNodeName
    } else if (nodeType == 'sequences') {
      return ''
    } else if (nodeType == 'paths') {
      return ''
    }
    return ''
  }

  public getPathsDisabled(nodeType: any) {
    if (nodeType == 'modules') {
      return false
    } else if (nodeType == 'sequences') {
      return true
    } else if (nodeType == 'path') {
      return true
    } else if (nodeType == 'pset') {
      return true
    } else if (nodeType == 'esproducers') {
      return true
    } else if (nodeType == 'essources') {
      return true
    } else if (nodeType == 'services') {
      return true
    }
    return true
  }

  public getPaths(nodeType: string) {
    if (nodeType == 'modules') {
      let values: Array<string> = []
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(
        this.getPathsContainingCurrentNode
      )) {
        values.push(value)
      }
      return values
    } else if (nodeType == 'sequences') {
      return []
    } else if (nodeType == 'path') {
      return []
    } else if (nodeType == 'pset') {
      return []
    } else if (nodeType == 'esproducers') {
      return []
    } else if (nodeType == 'essources') {
      return []
    } else if (nodeType == 'services') {
      return []
    }
    return []
  }

  //Table header BG color has to be changed this way
  public changeHeaderBGColor(backgroundColor: string) {
    let cols: any = document.getElementsByClassName('zk-table__header-row')
    for (let i = 0; i < cols.length; i++) {
      cols[i].style.backgroundColor = backgroundColor
    }
  }
}
